import { HttpClient } from '@angular/common/http';
import { Injectable, Optional } from '@angular/core';
import { PermissionGroup } from '@myrtls/api-interfaces';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { PERMISSIONS_API_URL } from '../../shared/utils/constants';
import {
    getPermissionsFailureAction,
    getPermissionsRequestAction,
    getPermissionsSuccessAction,
} from './permissions.actions';
import { AuthService } from '@auth0/auth0-angular';
import { SnackBarType } from '../../shared/models/snack-bar-config.model';
import { showSnackBarAction } from '../snack-bar/snack-bar.actions';

@Injectable()
export class PermissionsEffects {
    getPermissions$ = createEffect(() =>
        this.actions$.pipe(
            ofType(getPermissionsRequestAction),
            switchMap(() =>
                this.http.get<PermissionGroup[]>(PERMISSIONS_API_URL).pipe(
                    map(groups => getPermissionsSuccessAction({ groups })),
                    catchError(error =>
                        of(getPermissionsFailureAction({ error })),
                    ),
                ),
            ),
        ),
    );

    getPermissionsFailure$ = createEffect(() =>
        this.actions$.pipe(
            ofType(getPermissionsFailureAction),
            tap(() => {
                if (this.authService) {
                    this.authService.logout();
                }
            }),
            map(() => {
                return showSnackBarAction({
                    config: {
                        type: SnackBarType.FAILED,
                        description: 'Your session has timed out. Logging out.',
                    },
                });
            }),
        ),
    );

    constructor(
        private readonly actions$: Actions,
        private readonly http: HttpClient,
        @Optional() private authService: AuthService,
    ) {}
}
